import _ from 'lodash'
import { useState } from 'react'
import { savePartner } from '../fire'
import { useDeepState } from '../utils'
import api from '../api'
import NewPartnerUserEditor from './NewPartnerUserEditor'
import Select from './Select'

let PartnerEditor = ({ onClose, partner, clientIdOptions }) => {
  let [saving, setSaving] = useState(false)
  let [savedPartner, setSavedPartner] = useState(partner)
  let [addingNewUser, setAddingNewUser] = useState(false)
  let [deletingUserId, setDeletingUserId] = useState('')
  let [state, set] = useDeepState({
    id: '',
    name: '',
    users: null, // it'll be an object, not an array
    clientIds: null, // { id123: true, id345: true }
    ...partner,
  })
  let { name, id, users, clientIds } = state
  let clientIdsList = _.keys(clientIds)
  let newPartner = !savedPartner

  return (
    <div>
      <div>
        <div className="form">
          <div className="form-group">
            <div className="row">
              <div className="col-lg-4 col-sm-6">
                <label>Name</label>
                <input
                  onChange={e => set('name', e.target.value)}
                  className="form-control form-control-sm"
                  value={name}
                />
              </div>
              <div className="col-lg-4 col-sm-6">
                <label>ID</label>
                <input
                  readOnly={!newPartner}
                  onChange={e => set('id', e.target.value)}
                  className="form-control form-control-sm"
                  value={id}
                />
              </div>
            </div>
          </div>
          {newPartner ? (
            <div>
              <small>
                You will be able to create users after saving the first time.
              </small>
            </div>
          ) : (
            <>
              <div className="mb-3">
                <div>
                  Clients:{' '}
                  <Select
                    isMulti
                    className="col px-0 small mt-1"
                    onChange={change =>
                      set(
                        'clientIds',
                        _.transform(
                          change,
                          (acc, clientId) => {
                            acc[clientId] = true
                          },
                          {}
                        )
                      )
                    }
                    getOptionLabel={v => v}
                    options={clientIdOptions}
                    value={clientIdsList}
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Users</label>
                {_.map(users, (user, userId) =>
                  !user ? null : (
                    <div className="row mb-1 mr-0" key={userId}>
                      <div className="col-lg-3 pr-0">
                        <input
                          onChange={e =>
                            set(['users', userId, 'name'], e.target.value)
                          }
                          className="form-control form-control-sm"
                          placeholder="Name"
                          value={user.name}
                        />
                      </div>
                      <div className="col-lg-3 pr-0">
                        <input
                          className="form-control form-control-sm"
                          placeholder="Phone number"
                          onChange={e =>
                            set(
                              ['users', userId, 'phoneNumber'],
                              e.target.value
                            )
                          }
                          value={user.phoneNumber}
                        />
                      </div>
                      <div className="col-lg-3 pr-0">
                        <input
                          className="form-control form-control-sm"
                          readOnly
                          value={user.email}
                        />
                      </div>
                      <div className="col-lg-3">
                        <button
                          className="ml-2 btn btn-danger btn-sm"
                          disabled={deletingUserId === userId}
                          onClick={async () => {
                            if (
                              window.confirm(
                                'Are you sure you want to delete the user?'
                              )
                            ) {
                              setDeletingUserId(userId)
                              await api('/delete-partner-user', {
                                partnerId: id,
                                uid: userId,
                              })
                              setDeletingUserId('')
                              set(['users', userId], undefined)
                            }
                          }}
                        >
                          <i className="fa fa-remove" />
                        </button>
                      </div>
                    </div>
                  )
                )}
                {addingNewUser ? (
                  <NewPartnerUserEditor
                    partnerId={id}
                    partnerClientIds={clientIds}
                    onClose={() => setAddingNewUser(false)}
                    onSavedNewUser={newUser => {
                      setAddingNewUser(false)
                      set(
                        ['users', newUser.uid],
                        _.pick(newUser, ['email', 'name', 'phoneNumber'])
                      )
                    }}
                  />
                ) : (
                  <div className="my-2">
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => setAddingNewUser(true)}
                      disabled={!id || !name}
                    >
                      <i className="fa fa-plus" /> Add User
                    </button>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-end">
        <button
          className="btn btn-danger"
          disabled={saving}
          onClick={() => onClose()}
        >
          Cancel
        </button>
        <button
          className="ml-2 btn btn-success"
          disabled={saving}
          onClick={async () => {
            setSaving(true)
            try {
              let partnerForSave = {
                ...state,
                users: _.pickBy(state.users, u => !_.isUndefined(u)), // cuz they could be undefined when deleted.  could be done prettier eh?
              }
              await savePartner({
                oldPartner: savedPartner,
                partner: partnerForSave,
                clientIds,
              })
              if (newPartner) {
                setSavedPartner(partnerForSave)
                setSaving(false)
              } else {
                onClose()
              }
            } catch (e) {
              setSaving(false)
              console.log('error saving partner!', e)
              window.alert(e.message)
            }
          }}
        >
          Save {saving && <i className="fa fa-spinner fa-spin" />}
        </button>
      </div>
    </div>
  )
}

export default PartnerEditor
